import { render, staticRenderFns } from "./commissionSharing.vue?vue&type=template&id=56866fab&scoped=true"
import script from "./commissionSharing.vue?vue&type=script&lang=js"
export * from "./commissionSharing.vue?vue&type=script&lang=js"
import style0 from "./commissionSharing.vue?vue&type=style&index=0&id=56866fab&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56866fab",
  null
  
)

export default component.exports